export const MESSAGE_PREFIX = 'klaus|'
